export default "__VITE_ASSET__303f163d__"